import React from 'react';
import { Routes, Route, NavLink, useLocation } from 'react-router-dom';
import { Mail, Settings, Play, FileText, Zap, Layout } from 'lucide-react';

// Pages
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Sources from './pages/Sources';
import Emails from './pages/Emails';
import Generate from './pages/Generate';
import Automation from './pages/Automation';
import Template from './pages/Template';

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  // Homepage without navigation
  if (!isAdminRoute) {
    return (
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    );
  }

  // Admin routes with navigation
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <h1 className="text-xl font-bold text-gray-900">Newsletter Automation</h1>
            </div>

            <div className="flex space-x-4">
              <NavItem to="/admin" icon={<Zap size={20} />}>Dashboard</NavItem>
              <NavItem to="/admin/sources" icon={<Settings size={20} />}>Zdroje</NavItem>
              <NavItem to="/admin/emails" icon={<Mail size={20} />}>Emaily</NavItem>
              <NavItem to="/admin/generate" icon={<Play size={20} />}>Generovat</NavItem>
              <NavItem to="/admin/template" icon={<Layout size={20} />}>Šablona</NavItem>
              <NavItem to="/admin/automation" icon={<FileText size={20} />}>Automatizace</NavItem>
            </div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Routes>
          <Route path="/admin" element={<Dashboard />} />
          <Route path="/admin/sources" element={<Sources />} />
          <Route path="/admin/emails" element={<Emails />} />
          <Route path="/admin/generate" element={<Generate />} />
          <Route path="/admin/template" element={<Template />} />
          <Route path="/admin/automation" element={<Automation />} />
        </Routes>
      </main>
    </div>
  );
}

function NavItem({ to, icon, children }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
          isActive
            ? 'bg-primary-100 text-primary-700'
            : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
        }`
      }
    >
      {icon}
      <span>{children}</span>
    </NavLink>
  );
}

export default App;
